import React from "react";
import Cell from "../Cell";
import ModulePropertyDialog from "../ModulePropertyDialog";
import { SLIDING_MECHANISM_NAMES } from "../../../constants";
import { isMobileOnly } from "react-device-detect";

const MechanismCell = ({
  type,
  rowId,
  tempId,
  sectionId,
  isFiller = false,
  errorMessage,
  tableManager,
  propertyList = [],
  onContextMenu,
  viewMode,
  reviewColumnColorMap,
  onValueChange,
  dialogProps,
}) => {
  const getCellBackgroundColor = (column, value) => {
    if (!reviewColumnColorMap) return null;

    // Always use column-specific key to match the color map format
    const normalizedValue = value || "";
    const mapKey = `${column}__${normalizedValue}`;

    return reviewColumnColorMap[mapKey] || null;
  };

  const property = propertyList.find((prop) =>
    [
      "sliding_shutter_mechanism_2_door",
      "sliding_shutter_mechanism_3_door",
    ].includes(prop.identifier)
  );

  const selectedOption =
    property && property.options.find((opt) => opt.selected);

  let value = "";

  if (property && selectedOption) {
    if (viewMode === "review" && type === "module")
      value = SLIDING_MECHANISM_NAMES[selectedOption.identifier];
    else if (
      viewMode === "spec" &&
      (property.is_overridden_v2 || type === "section")
    )
      value = SLIDING_MECHANISM_NAMES[selectedOption.identifier];
  }

  if (viewMode === "review" && type === "module")
    onValueChange(rowId, "review_sliding_mechanism", (value || "").trim());

  const backgroundColor =
    viewMode === "review"
      ? getCellBackgroundColor("review_sliding_mechanism", value)
      : undefined;

  return (
    <Cell
      rowId={rowId}
      sectionId={sectionId}
      rowType={type}
      column="mechanism"
      className="flex-grow-0 flex-shrink-0"
      customStyles={{
        width: isMobileOnly ? "15%" : "85px",
        backgroundColor: backgroundColor || undefined,
      }}
      tableManager={tableManager}
    >
      {type === "module" && (
        <>
          <div className="fs-10px">{value}</div>

          {tableManager.isActive(type, rowId, "mechanism") && (
            <ModulePropertyDialog {...dialogProps} properties={[property]} />
          )}
        </>
      )}
    </Cell>
  );
};

export default MechanismCell;
